<app-dynamic-component *ngFor="let panel of items" [data]="panel" id="{{ panel.anchor?.value }}"></app-dynamic-component>